/*
 * Yup for phone number validation.
 * Is optional by default, can be changed.
 * Has default error message, can be changed.
 */
import * as yup from 'yup'
import { phoneRegex } from '../strings/regex'

const defaultMessage =
  'Please provide a phone number in the format ###-###-####'

export const phoneYup = (required = false, errorMessage = defaultMessage) =>
  required
    ? yup
        .string()
        .matches(phoneRegex, {
          message: errorMessage,
          excludeEmptyString: false
        })
        .required(errorMessage)
    : yup.string().matches(phoneRegex, {
        message: errorMessage,
        excludeEmptyString: true
      })
